import React from "react";
const terms = () => {
  return (
    <div>
      <div
        style={{
          marginTop: "25px"
        }}
      >
        <div
          style={{
            fontSize: "15px",
            color: "grey",
            marginTop: "15px"
          }}
        ></div>
        <div style={{ margin: "5px" }}>
          <lu>
            <li
              style={{
                display: "block",
                backgroundColor: "white",
                margin: "2px",
                padding: "5px"
              }}
            >
              This is an online delivery service.
            </li>

            <li
              style={{
                display: "block",
                backgroundColor: "white",
                margin: "2px",
                padding: "5px"
              }}
            >
              We strive our best to deliver as soon as possible, within next
              day. However we are getting overwhelmed by volume of orders
              received and our suppliers also require time for packaging.
            </li>
            <li
              style={{
                display: "block",
                backgroundColor: "white",
                margin: "2px",
                padding: "5px"
              }}
            >
              For same day delivery (with nominal additional charge) please
              contact us at +65 94562455
            </li>
          </lu>
        </div>
      </div>
    </div>
  );
};

export default terms;



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/terms.jsx